import { z } from 'zod';
import { authFetch } from '@os/auth-client';
import { auth } from '@/app/auth';

const BASE = (import.meta.env.VITE_API_BASE as string | undefined) ?? '/api/v1';

export class ApiError extends Error {
  constructor(public status: number, public code: string, message: string, public details?: unknown) { super(message); this.name = 'ApiError'; }
}
async function toApiError(res: Response): Promise<ApiError> {
  const json = (await res.json().catch(() => null)) as { error?: { code?: string; message?: string; details?: unknown } } | null;
  return new ApiError(res.status, json?.error?.code ?? 'http_error', json?.error?.message ?? `Request failed (${res.status})`, json?.error?.details);
}
/** Typed JSON call: bearer token + refresh-on-401 from `@os/auth-client`, zod parse of the response (§52). */
export async function api<S extends z.ZodTypeAny>(path: string, opts: { method?: string; body?: unknown; schema?: S; signal?: AbortSignal } = {}): Promise<z.infer<S>> {
  const res = await authFetch(auth, `${BASE}${path}`, { method: opts.method ?? 'GET', headers: opts.body !== undefined ? { 'Content-Type': 'application/json' } : {}, body: opts.body !== undefined ? JSON.stringify(opts.body) : undefined, signal: opts.signal });
  if (res.status === 204) return undefined as z.infer<S>;
  if (!res.ok) throw await toApiError(res);
  const json = await res.json().catch(() => null);
  return opts.schema ? opts.schema.parse(json) : (json as z.infer<S>);
}
export const qs = (params: Record<string, string | number | boolean | undefined | null | string[]>) => {
  const sp = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) { if (v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0)) continue; sp.set(k, Array.isArray(v) ? v.join(',') : String(v)); }
  const s = sp.toString();
  return s ? `?${s}` : '';
};
